import Button from "@components/common/Button";
import {
  IAccommodationResponse,
  IActivityResponse,
  ILocationResponse,
  IPackageResponse,
  ITravelConsultantResponse,
} from "@customTypes/modelResponses";
import { useState } from "react";
import useViewMoreFetching from "../hooks/useViewMoreFetching";

interface Map {
  [key: number]: string;
}
const ITEMS_PER_ROW: Map = {
  1: "grid-cols-1 desktop:desktop:grid-cols-1",
  2: "grid-cols-1 desktop:desktop:grid-cols-2",
  3: "grid-cols-1 desktop:desktop:grid-cols-3",
  4: "grid-cols-1 desktop:desktop:grid-cols-4",
};

export type ICardBuilder = (
  item: IPackageResponse &
    ILocationResponse &
    IActivityResponse &
    IAccommodationResponse &
    ITravelConsultantResponse
) => JSX.Element;

interface ITopSectionGrid {
  items: JSX.Element[];
  gridItemsPerRow?: number;
  gridItemsLimit?: number;
  total: number;
  cardBuilder?: ICardBuilder;
}

const TopSectionGrid = ({
  items,
  gridItemsPerRow,
  gridItemsLimit = 9,
  total,
  cardBuilder,
}: ITopSectionGrid): JSX.Element => {
  const [showViewMore, setShowViewMore] = useState(items.length < total);
  const { cardsToDisplay, onClickHandler } = useViewMoreFetching({
    initialItems: items,
    itemsDisplayedAmount: gridItemsLimit,
    total,
    setShowViewMore,
    cardBuilder,
  });

  return (
    <>
      <div
        className={`grid justify-center gap-x-[2rem] gap-y-[2rem] ${
          ITEMS_PER_ROW[gridItemsPerRow ?? 3]
        } mt-5 mb-1 mr-5 desktop:mr-0`}
      >
        {cardsToDisplay}
      </div>
      {showViewMore && (
        <div className="mx-5 mt-5 ml-0 desktop:mx-auto desktop:w-[30rem]">
          <Button variant="tertiary" onClick={onClickHandler}>
            <>View More</>
          </Button>
        </div>
      )}
    </>
  );
};

export default TopSectionGrid;
